import { createSlice } from "@reduxjs/toolkit";
import { FailedcustomerTagResponse } from "../../../constants/error_messages";
import { CUSTOMER_TAG } from "../../../constants/reducer_names";
import { createCustomerTag } from "../../api/customerTag";

const initialState = {
  createLoading: false,
  customerTagName: "",
  copyCustomerTagName: "",
  description: "",
  status: 0,
  showError: false,
  isUpdateCustomer: false,
  isClosepopup: false,
  handleCheck: 0,
  isCancelpopup: false,
  responseError: {
    hasError: false,
    errorMessage: "",
  },
  currentCustomer: {} as any,
  nameExistError: false,
  isDefault: false,
  copyCustomerTagNamecopy: "",
} as any;

const CreateCustomerTagSlice = createSlice({
  name: CUSTOMER_TAG,
  initialState,
  reducers: {
    storeCustomerTag: (state) => {
      state.isClosepopup = !state.isClosepopup;
      state.nameExistError = false;
    },
    cancelPOpup: (state) => {
      state.isCancelpopup = !state.isCancelpopup;
    },
    storeUpdateCustomerTag: (state) => {
      state.isUpdateCustomer = !state.isUpdateCustomer;
    },
    storeisDefault: (state) => {
      state.isDefault = !state.isDefault;
    },
    handleCustomerTags: (state, { payload }) => {
      state.customerTagName = payload;
      state.nameExistError=false;
      let regex = /^[a-zA-Z ]*$/;
      if (payload.match(regex)) {
        state.showError = false;
      } else {
        state.showError = true;
      }
    },
    descriptionCustomerTags: (state, { payload }) => {
      state.description = payload;
    },
    statusCustomerTags: (state, { payload }) => {
      state.status = payload;
    },
    setCurrentCustomer: (state, { payload }) => {
      state.currentCustomer = payload;
      state.copyCustomerTagNamecopy = payload.customerTagName;
      state.copyCustomerTagName = payload.customerTagName;
      state.customerTagName = payload.customerTagName;
      state.description = payload.description;
      state.status = payload.status;
    },
    setError: (state) => {
      state.nameExistError = !state.nameExistError;
    },
    reset: () => {},
  },

  extraReducers: (builder) => {
    builder.addCase(createCustomerTag.pending, (state) => {
      state.createLoading = true;
    });
    builder.addCase(createCustomerTag.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.responseError.hasError = false;
        state.responseError.errorMessage = "";
      } else {
        state.responseError.hasError = true;
        state.responseError.errorMessage =
          payload?.message ?? FailedcustomerTagResponse;
      }
      state.createLoading = false;
    });
    builder.addCase(createCustomerTag.rejected, (state, { payload }: any) => {
      state.responseError.hasError = true;
      state.responseError.errorMessage =
        payload?.message ?? FailedcustomerTagResponse;
      state.createLoading = false;
    });
  },
});
export const createCustomerTagAction = CreateCustomerTagSlice.actions;
export default CreateCustomerTagSlice.reducer;
